import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-left\">\n<path d=\"M10.0007 3.50167C10.1274 3.50167 10.254 3.54833 10.354 3.64833C10.5474 3.84167 10.5474 4.16167 10.354 4.355L6.70736 8.00167L10.354 11.6483C10.5474 11.8417 10.5474 12.1617 10.354 12.355C10.1607 12.5483 9.84069 12.5483 9.64736 12.355L5.64736 8.355C5.45402 8.16167 5.45402 7.84167 5.64736 7.64833L9.64736 3.64833C9.74736 3.54833 9.87402 3.50167 10.0007 3.50167Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol